import { motion } from "framer-motion";
import { containerVariants, cardVariants } from "../utils/variants";
import { COLORS } from "../constants/colors";

const FeaturesSection = ({ features }) => {
  return (
    <section
      className="py-20 px-8 md:px-16"
      style={{ backgroundColor: COLORS.background }}
    >
      <h2
        className="text-4xl font-bold text-center mb-12"
        style={{ color: COLORS.primaryDark }}
      >
        One Platform for Complete School Management
      </h2>

      <motion.div
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {features.map((item, i) => (
          <motion.div
            key={i}
            variants={cardVariants}
            className="p-8 rounded-2xl border text-center transition-transform hover:-translate-y-2"
            style={{
              backgroundColor: COLORS.primaryLight,
              borderColor: COLORS.primaryLight,
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            }}
          >
            <div className="mb-3">{item.icon}</div>
            <h3
              className="text-xl font-semibold mb-2"
              style={{ color: COLORS.primaryDark }}
            >
              {item.title}
            </h3>
            <p className="text-gray-600 text-sm">{item.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default FeaturesSection;
